import React from "react"
import { message } from 'antd'
import { Route, Switch } from 'react-router-dom'
import createHashHistory from 'history/createHashHistory'
import Footer from '../../components/common/NHFooter/index'
import HeaderSearch from './headerSearch'
import Process from './process'
import StepForm from './steps/index'

import styles from './index.css'
import NHFetch from "../../utils/NHFetch";

const hashHistory = createHashHistory();
const basicUrl = '/yxxc/'; //基础请求路径

export default class Welcome extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            lcid: '', //当前流程ID
            dqlcpz: {}, //当前流程配置信息
            lcpzData: [], //所有流程配置信息
            studentData: {}, //学生信息
            pieData: {}, //流程统计数据
            stepsData: [], //流程步骤配置信息
            hjblztData: {},//环节办理状态信息
            hjywxData: [],//环节业务项信息
            ybllchjData: [],//学生已办理的流程环节
            searchParams: {}
        }
    }

    componentDidMount() {
        if (!this.state.lcpzData || this.state.lcpzData.length == 0) {
            hashHistory.push('/yxxc');
        }
    }

    //当流程加载完毕时回调
    handleProcessLoad = (lcid, dqlcpz, lcpzData) => {
        //保存当前流程ID、配置信息
        this.setState({
            lcid: lcid,
            dqlcpz: dqlcpz,
            lcpzData: lcpzData,
            studentData: {},
            pieData: {},
            stepsData: [],
            hjblztData: {},
            hjywxData: [],
            ybllchjData: [],
        });
    }

    //搜索
    handleSearch = (searchParams, onFinish) => {

        //查询学生信息
        let p1 = this.getStudentData(searchParams);

        Promise.all([p1]).then((res) => {
            onFinish();
        }).catch((err) => {
            onFinish();
        });
    }

    //查询学生信息
    getStudentData = (searchParams, flag) => {
        this.setState({ searchParams: searchParams });
        return NHFetch(basicUrl + 'getStudentInfoByFilter', 'GET', searchParams)
            .then(res => {
                if (res) {
                    let data = res.data;
                    if (data) {
                        let dqlcpz = this.state.lcpzData.filter(item => item.lcdyVO.pkid == data.lcid)[0];
                        this.setState({ studentData: data, lcid: data.lcid, dqlcpz: dqlcpz }, () => {
                            //根据流程ID获取流程总体报到统计数据
                            this.loadPieStatisticalData(data.lcid);
                            //获取流程环节办理统计数据
                            this.loadStepsStatisticalData(data.lcid);
                            //获取学生已办理的流程环节
                            this.getAllLinkOfFinish(data.xsid);
                            //跳转页面
                            this.linkToStep(data, flag);
                        });

                    } else {
                        message.error('未查询到学生信息，可能原因：1.学生帐号不存在；2.当前登录用户无办理该学生的权限；3.学生未加入到迎新流程');
                        this.setState({ studentData: {}, hjblztData: {}, hjywxData: {} });
                    }
                }
            });
    }

    //根据流程ID获取流程总体报到统计数据
    loadPieStatisticalData = (lcid = '') => {
        let userId = '';
        return NHFetch(basicUrl + 'getPieStatisticalData', 'GET', { lcid: lcid,userId:userId })
            .then(res => {
                if (res) {
                    let data = res.data;
                    if (data) {
                        let pieData = { bdrs: data.bdrs ? data.bdrs : 0, zrs: data.zrs ? data.zrs : 0 };
                        this.setState({ pieData: pieData });
                    } else {
                        this.setState({ pieData: { bdrs: 0, zrs: 0 } });
                    }
                }
            });
    }

    //获取流程环节办理统计数据
    loadStepsStatisticalData = (lcid = '') => {
        let userId = '';
        return NHFetch(basicUrl + 'getTableStatisticalData', 'GET', { lcid: lcid,userId:userId })
            .then(res => {
                if (res) {
                    let data = res.data;
                    if (data) {
                        this.setState({ stepsData: data });
                    } else {
                        this.setState({ stepsData: [] });
                    }
                }
            });
    }

    //获取环节办理状态信息
    getHjblztData = (params) => {

        NHFetch(basicUrl + 'getHjblztByFilter', 'GET', params)
            .then(res => {
                if (res) {
                    let data = res.data;
                    if (data) {
                        let blzt = data.blzt;
                        this.setState({ hjblztData: data });
                    } else {
                        this.setState({ hjblztData: {} });
                    }
                }
            });
    }

    //获取环节业务项信息
    getHjywxData = (params) => {

        NHFetch(basicUrl + 'getHjywxByFilter', 'GET', params)
            .then(res => {
                if (res) {
                    let data = res.data;
                    if (data) {
                        this.setState({ hjywxData: data });
                    } else {
                        this.setState({ hjywxData: [] });
                    }
                }
            });
    }

    //获取学生所有已办理的流程环节
    getAllLinkOfFinish = (xsid) => {
        NHFetch(basicUrl + 'getAllLinkOfFinishedByXsid', 'GET', { xsid })
            .then(res => {
                if (res) {
                    let data = res.data;
                    if (data) {
                        this.setState({ ybllchjData: data });
                    } else {
                        this.setState({ ybllchjData: [] });
                    }
                }
            });
    }

    //查询学生信息后，默认跳转到当前用户有操作权限的第一个的步骤页面，如果是取消或办理环节（flag为submit或cancel），则留在当前步骤
    linkToStep = (studentData, flag) => {
        let { lchjVOs } = this.state.dqlcpz;
        if (lchjVOs) {

            // 如果是取消或办理环节（flag为submit或cancel），则留在当前步骤，只刷新学生环节办理状态与数据
            if (flag) {
                let urlParams = this.parseUrlParams();
                let hjywxFilterParams = {};//环节业务项过滤条件
                hjywxFilterParams.xsid = studentData.xsid;
                hjywxFilterParams.hjid = urlParams.hjid;
                hjywxFilterParams.lchjid = urlParams.lchjid;

                this.getHjblztData(hjywxFilterParams);
                this.getHjywxData(hjywxFilterParams);

            } else {
                let currentStep = 0;
                //获取当前有操作权限的、可操作的第一个环节
                let available = lchjVOs.filter(item => item.czqx == '1' && item.zt == '1')[0];
                if (available) {
                    //获取第一个可操作环节代码
                    let { pkid, hjid, hjdm } = available;
                    for (let key = 0; key < lchjVOs.length; key++) {
                        if (lchjVOs[key].hjdm == hjdm) {
                            //当前可操作环节在整个流程步骤中的位置
                            currentStep = key;
                            break;
                        }
                    }

                    let filter = encodeURIComponent(`key=${currentStep}&lcid=${this.state.lcid}&hjid=${hjid}&lchjid=${pkid}`);

                    //如果是自定义环节
                    if (hjdm.indexOf('ZDY') != -1) {

                        hashHistory.push({
                            pathname: '/yxxc/step',
                            search: filter
                        });
                    } else {
                        switch (hjdm) {
                            case 'GD001':
                                //绿色通道
                                hashHistory.push({
                                    pathname: '/yxxc/step/lstd',
                                    search: filter
                                });
                                break;
                            case 'GD002':
                                //缴费办理
                                hashHistory.push({
                                    pathname: '/yxxc/step/jfbl',
                                    search: filter
                                });
                                break;
                            case 'GD003':
                                //宿舍分配
                                hashHistory.push({
                                    pathname: '/yxxc/step/ssfp',
                                    search: filter
                                });
                                break;
                            default:
                                message.error(`暂未配置代码为${hjdm}的环节页面，请联系管理员`);
                                break;
                        }
                    }

                    let hjywxFilterParams = {};//环节业务项过滤条件
                    hjywxFilterParams.xsid = studentData.xsid;
                    hjywxFilterParams.hjid = hjid;
                    hjywxFilterParams.lchjid = pkid;

                    this.getHjblztData(hjywxFilterParams);
                    this.getHjywxData(hjywxFilterParams);

                } else {
                    message.warning(`暂无可操作的环节，请检查是否已分配环节权限或环节是否启用`);
                }
            }

        }
    }

    //解析url搜索参数
    parseUrlParams() {
        let location = this.props.location;
        if (location) {
            const { search } = location;
            if (search) {
                let deocodeUrl = decodeURIComponent(search);
                let url = deocodeUrl.substring(1, search.length); //去除?
                let paramsStr = url.split('&'); //分割参数字符串

                if (paramsStr.length > 0) {

                    let params = {};
                    //解析成键值对形式对象
                    for (let key in paramsStr) {
                        let paramStr = paramsStr[key];
                        let paramObj = paramStr.split('=');
                        let obj = new Object;
                        obj[paramObj[0]] = paramObj[1];
                        Object.assign(params, obj);
                    }

                    return params;
                }
            }
        }
        return null;
    }

    // 获取路径中的当前步骤
    getCurrentStep() {
        let params = this.parseUrlParams();
        if (params) {
            return Number(params.key ? params.key : 0);
        }
    }

    // 环节办理完成回调
    handleFinish = (flag) => {
        let searchParams = this.state.searchParams;
        this.getStudentData(searchParams, flag);
        if (flag == 'submit' && this.headerSearch) {
            this.headerSearch.clear();
        }
    }

    render() {

        const { lcid, dqlcpz, studentData, pieData, stepsData, hjblztData, hjywxData, ybllchjData } = this.state;

        return (
            <div>
                <div className={styles.page_header}>
                    <div className={styles.detail}>
                        <div className={styles.main}>
                            <div className={styles.row}>
                                <div className={styles.content}>
                                    <HeaderSearch wrappedComponentRef={(inst) => this.headerSearch = inst} onSearch={this.handleSearch} lcid={lcid} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <Switch>
                        <Route
                            exact path="/yxxc"
                            render={({ location }) =>
                                <Process location={location} onLoad={this.handleProcessLoad} />
                            }
                        />
                        <Route
                            path="/yxxc/step"
                            render={({ location }) =>
                                <StepForm
                                    location={location}
                                    lcid={lcid}
                                    studentData={studentData}
                                    lcpz={dqlcpz}
                                    pieData={pieData}
                                    stepsData={stepsData}
                                    hjblztData={hjblztData}
                                    hjywxData={hjywxData}
                                    ybllchjData={ybllchjData}
                                    onFinish={this.handleFinish}
                                />
                            }
                        />
                    </Switch>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./components/yxxc/index.js